import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import logo from "../../assets/logo/logo.png"; // Ensure the correct path
import "./navbar.css";
import Popupboxx from "../popupboxx/Popupboxx";

function Navbar() {;
  const [isPopupOpen, setIsPopupOpen] = useState(false)
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light fixed-top shadow-sm nav-color-bck">
        <div className="container">
          {/* Logo Section */}
          <a
            className="navbar-brand"
            href="/"
           
          >
            <img
              src={logo}
              alt="Logo"
              width="58"
              height="51"
              style={{ marginRight: "4px" }}
            />
            First Sky Infrastructure
          </a>


          {/* Get Enquiry Button */}
          <button className="btn get-button" onClick={() => setIsPopupOpen(true)}>
            Get Enquiry
          </button>
        </div>
      </nav>

      
      <Popupboxx
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
    </>
  );
}

export default Navbar;
